import { __rest } from "tslib";
import React, { forwardRef, useCallback } from 'react';
import { Choice } from '../Choice';
import { Input } from './styled';
import { generateId } from '../../utils/generateId';
export const Radio = forwardRef((_a, ref) => {
    var { checked, value, name, disabled, onChange, id } = _a, otherProps = __rest(_a, ["checked", "value", "name", "disabled", "onChange", "id"]);
    const handleChange = useCallback((e) => {
        onChange(e.currentTarget.checked, value);
    }, [onChange, value]);
    const componentId = id !== null && id !== void 0 ? id : generateId('radio');
    return (React.createElement(Choice, Object.assign({ id: componentId, disabled: disabled }, otherProps),
        React.createElement(Input, { id: componentId, type: "radio", checked: checked, value: value, name: name, disabled: disabled, onChange: handleChange, ref: ref })));
});
//# sourceMappingURL=Radio.js.map